import { listQueryInput, paginated } from './list.js';
import { auditEventSchema } from './cross.js';
/**
 * F49 — `/activity`, the user-scoped read over `audit_events`. Same
 * append-only store the admin F59 `/audit` viewer (`./admin.ts`
 * `adminAuditListQuery`/`adminAuditListResult`) reads — this is the narrower,
 * self-service half: `WHERE actorUserId = {caller} AND impersonatedUserId IS
 * NULL`, enforced server-side (never a client-supplied `userId` filter).
 *
 * §15.1 / F49 AC: actions taken WHILE a staff member is impersonating this
 * user are attributed to the STAFF actor and are EXCLUDED here — they only
 * ever appear in the admin audit viewer with `impersonatedUserId` set.
 */
export const activitySortColumns = ['createdAt'];
export const activityListQuery = listQueryInput(activitySortColumns, {
    defaultSort: 'createdAt',
});
export const activityListResult = paginated(auditEventSchema);
